<template>
  <form class="ui form settings" @submit.prevent="submit">
    <div class="ui grid onboarding-h1-row">
      <div class="sixteen wide column">
        <h1>Welcome to Smardie</h1>
      </div>
    </div>

    <div class="ui stackable grid onboarding-content-row">
      <div class="sixteen wide mobile eight wide computer column">
        <p class="body-large">
          We just need a few basic details so we can set your account up correctly.
        </p>
        <p class="body-large">
          The following information will be displayed on all external documents sent from your account. Don't worry you can update them later on the Settings page.
        </p>
        <div class="field settings">
          <label>Branding / Logo</label>
          <div class="upload-displayed-logo">
            <app-images
              :parent_item="form"
              :save="saveLogo"
              :resize="false"
              @images="form.images = $event"
            />
          </div>
        </div>
      </div>
      <div class="sixteen wide mobile eight wide computer column">
        <div class="field settings">
          <label>Business Name*</label>
          <input
            v-model="form.business_name"
            type="text"
            placeholder="Enter Business Name"
            v-bind:class="{ error: errors.business_name }"
            @input="clearErrorWhenValid('business_name')"
          />
        </div>
        <div class="field settings">
          <label>Business Phone Number*</label>
          <input
            v-model="form.phone"
            type="text"
            placeholder="Enter Phone Number"
            v-bind:class="{ error: errors.phone }"
            @input="clearErrorWhenValid('phone')"
          />
        </div>
        <div class="field settings">
          <label>Business Email Address*</label>
          <input
            v-model="form.email"
            type="email"
            placeholder="Enter email address"
            v-bind:class="{ error: errors.email }"
            @input="clearErrorWhenValid('email')"
          />
        </div>
        <div class="field settings">
          <label>Business ABN*</label>
          <input
            v-model="form.abn"
            type="text"
            placeholder="Enter ABN"
            v-bind:class="{ error: errors.abn }"
            @input="clearErrorWhenValid('abn')"
          />
        </div>
      </div>
    </div>

    <div class="ui divider onboarding-divider"></div>

    <div class="onboarding-actions">
      <button
        type="submit"
        class="ui primary button settings-save-btn"
        :class="{ loading: saving }"
        :disabled="saving"
      >
        Continue
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import images from '../../components/common/image/images';

export default {
  name: 'OnboardingWelcome',
  components: {
    'app-images': images
  },
  data() {
    return {
      form: {
        business_name: '',
        phone: '',
        email: '',
        abn: '',
        images: []
      },
      errors: {},
      saving: false
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      axios.get('/api/setting/display').then((res) => {
        this.form.business_name = res.data.business_name || '';
        this.form.phone = res.data.phone || '';
        this.form.email = res.data.email || '';
        this.form.abn = res.data.abn || '';
        this.form.images = res.data.images || [];
      }).catch(() => {
        this.errorNotification('Failed to load settings');
      });
    },
    saveLogo() {
      axios.put('/api/setting/display', {
        business_name: this.form.business_name,
        phone: this.form.phone,
        email: this.form.email,
        abn: this.form.abn,
        images: this.form.images,
        quote_terms: '',
        invoice_terms: '',
        invoice_payment_terms: '',
        address: {}
      }).catch(() => {});
    },
    clearErrorWhenValid(field) {
      const value = (this.form[field] || '').trim();
      if (value) this.$set(this.errors, field, false);
    },
    validate() {
      this.errors = {};
      if (!(this.form.business_name || '').trim()) this.errors.business_name = true;
      if (!(this.form.phone || '').trim()) this.errors.phone = true;
      if (!(this.form.email || '').trim()) this.errors.email = true;
      if (!(this.form.abn || '').trim()) this.errors.abn = true;
      return Object.keys(this.errors).length === 0;
    },
    submit() {
      if (!this.validate()) {
        this.errorNotification('Please fill in all required fields (Business Name, Phone, Email, ABN).');
        return;
      }
      this.saving = true;
      // Send explicit payload so phone/ABN always reach the backend (onboarding step 1 → companies table)
      const payload = {
        business_name: String(this.form.business_name || '').trim(),
        phone: String(this.form.phone || '').trim(),
        email: String(this.form.email || '').trim(),
        abn: String(this.form.abn || '').trim(),
        images: Array.isArray(this.form.images) ? this.form.images : [],
        quote_terms: '',
        invoice_terms: '',
        invoice_payment_terms: '',
        address: {}
      };
      axios.put('/api/setting/display', payload).then(() => {
        this.$router.push('/onboarding/job-settings');
      }).catch((err) => {
        this.errorNotification((err.response && err.response.data && err.response.data.error) || 'Failed to save. Please try again.');
      }).finally(() => {
        this.saving = false;
      });
    },
  }
};
</script>

<style scoped>
.onboarding-h1-row {
  margin-bottom: 0;
}
.onboarding-content-row {
  margin-top: 1rem;
}
.onboarding-divider {
  margin: 2rem 0 0 0;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.onboarding-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 0;
}
</style>
